module.exports = __webpack_public_path__ + "img/WildForDolphins_DG.a88b9166.png";